import * as angular from "angular";
import { formatDurationExact } from "../utils/duration-exact.util";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDurationExact', bringozDurationExact);

function bringozDurationExact() {
  return function bringozDurationExactFilter(duration) {
    return formatDurationExact(duration);
  }
}
